export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";